import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdMisangListTrms = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchGrdc: '',
        searchLoca: '',
    });

    const searchParamsAdditional = {};

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['기관명', '환자수', '사고종류', '손상유형', '추락사고 보호장구 착용여부', '기타사고 보호장구 착용여부', '직업관련', '손상발생일시', '주증상 발생일시', '사고발생지역_시,도', '사고발생장소', '내원전 심정지 유무', '내원전 보고 유무', '내원시 GCS_총점', '내원시 GCS_평가가능여부', '알콜 섭취여부', '기저질환 여부', '퇴실시 GCS_총점', '퇴실시 GCS_평가가능여부']; //component화 
    const dataColumn = ['ANNYDESC', 'ANNYTOTL', 'ANNYACKN', 'ANNYDMTP', 'ANNYPFYN', 'ANNYPHYN', 'ANNYPAYN', 'ANNYHUDTM', 'ANNYMNDTM', 'ANNYACA1', 'ANNYPLCE', 'ANNYARYN', 'ANNYREYN', 'ANNYVGCT', 'ANNYINGT5', 'ANNYALYN', 'ANNYBD32', 'ANNYOGCT', 'ANNYONGN5'];
    const apiCall = '/ptmiapi/gumto/gumBdosmisang_search.do';
    const apiCntCall = '';
    const excelFileName = '미상데이터';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>
                                내원일자
                            </th>
                            <td colSpan={5}>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                    className="calendar width_70"
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                    className="calendar width_70"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <p>* 외상등록체계 항목 중 '미상'으로 입력되어진 항목의 건수와 입력 비율을 표시합니다.<br />
                * 미상데이터 비율이 5%가 초과하지 않도록 관리해 주십시요.</p>
        </Main>
    )
}

export default BdMisangListTrms;